import { TrackList } from "@/components/tracks/TrackList";
import { useLibrary } from "@/hooks/useLibrary";
import { usePlayer } from "@/hooks/usePlayer";

export function LikedPage() {
  const { likedTracks } = useLibrary();
  const p = usePlayer();
  return (
    <div>
      <div className="row" style={{ justifyContent: "space-between", marginBottom: 14 }}>
        <h1 style={{ margin: 0 }}>Titres likés</h1>
        <button className="btn primary" onClick={() => void p.play(likedTracks, 0)}>▶ Lire tout</button>
      </div>
      <TrackList tracks={likedTracks} />
    </div>
  );
}
